module.exports = __webpack_public_path__ + "img/blankpage_jiangyi.21563f4d.png";